import { render, staticRenderFns } from "./buyer-2.vue?vue&type=template&id=bab5ac88"
import script from "./buyer-2.vue?vue&type=script&lang=js"
export * from "./buyer-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports